export class Pagination {
  public currentPage: number
  public pageCount: number
  public pageSize: number
  public rowCount: number
  public firstRowOnPage: number
  public lastRowOnPage: number

  constructor(
    currentPage: number,
    pageCount: number,
    pageSize: number,
    rowCount: number,
    firstRowOnPage: number,
    lastRowOnPage: number
  ) {
    this.currentPage = currentPage
    this.pageCount = pageCount
    this.pageSize = pageSize
    this.rowCount = rowCount
    this.firstRowOnPage = firstRowOnPage
    this.lastRowOnPage = lastRowOnPage
  }
}
